import {
  Menu,
  Section,
  SectionItem
} from '@com-delta-idp/mnx-skymiles-landing-page-ui';
import {
  AEMErrorMessage,
  getEmptyContent,
  getLink,
  isValidData
} from '@com-delta-idp/mnx-skymiles-shared';
import { logError } from '@com-delta-idp/mnx-utils';
import {
  AEMMenuContent,
  Detail,
  SideNavigation
} from '../models/aem/menu.interfaces';

export const getMenu = (
  featureFlag: boolean | undefined,
  aem: AEMMenuContent | undefined,
  error: string | undefined,
  aemErrorMessages: AEMErrorMessage[] | undefined,
  businessTraveler: boolean | undefined,
  aemBusinessTravelerFeatureFlag: boolean | undefined
): Menu => {
  try {
    if (error) {
      return getEmptyContent<Menu>(error, aemErrorMessages);
    }
    return isValidData<
      string,
      [AEMMenuContent | undefined, boolean | undefined]
    >('menu', aem, featureFlag)
      ? adaptMenu(
          featureFlag as boolean,
          aem as AEMMenuContent,
          businessTraveler as boolean,
          aemBusinessTravelerFeatureFlag as boolean
        )
      : getEmptyContent<Menu>();
  } catch (error) {
    logError(error as Error, 'SKYMILES', 'LANDING_PAGE', 'MENU');
    return getEmptyContent<Menu>('full-page', aemErrorMessages, true, true);
  }
};

const adaptMenu = (
  featureFlag: boolean,
  aem: AEMMenuContent,
  businessTraveler: boolean,
  aemBusinessTravelerFeatureFlag: boolean
): Menu => {
  return {
    sections: getSections(
      aem.menu.sideNavigation,
      businessTraveler,
      aemBusinessTravelerFeatureFlag
    ),
    disabled: !featureFlag,
    loaded: true
  };
};

const getSections = (
  sideNavigation: SideNavigation[],
  businessTraveler: boolean,
  aemBusinessTravelerFeatureFlag: boolean
): Section[] => {
  const result: Section[] = [];

  sideNavigation.forEach((element: SideNavigation) => {
    const section: Section = {
      id: element.id,
      title: element.label,
      items: [],
      url: element.details?.length !== 0 ? '' : element.pagePath,
      opened: isActive(element)
    };

    element.details.forEach((item: Detail, itemIndex: number) => {
      const sectionItem: SectionItem = {
        id: item.id,
        link: getLink(item.title, item.url),
        selected: checkFeatureSelected(element.details, itemIndex)
      };

      if (businessTraveler && aemBusinessTravelerFeatureFlag) {
        section.items.push(sectionItem);
      } else {
        if (sectionItem.id !== 'businesstraveleroverview') {
          section.items.push(sectionItem);
        }
      }
    });
    result.push(section);
  });

  return result;
};

const checkFeatureSelected = (
  details: Detail[],
  itemIndex: number
): boolean => {
  return window.location.pathname === details[itemIndex].url;
};

const isActive = (element: SideNavigation): boolean => {
  if (element.details?.length === 0) {
    return isActiveUrl(element.pagePath);
  } else {
    return element.details?.some((item) => isActiveUrl(item?.url));
  }
};

const isActiveUrl = (url: string): boolean => {
  const currentWindowUrl = window.location.href
    .replace(/-/g, '')
    .replace(/\s+/g, '')
    .toLowerCase();
  const sectionUrl = url.replace(/-/g, '').replace(/\s+/g, '').toLowerCase();
  return currentWindowUrl.includes(sectionUrl);
};
